import React from 'react'

import Form from '../../../gd-form/form/form-modal-new/form-modal-new'
import FormManager from '../../../gd-form/common/form-manager'
import FormError from '../../../gd-form/common/form-error/form-error'
import Input from '../../../gd-form/form-element/input/input'
// import {ProjectSystemTypeIcon} from "../../../model2/project/types"
import ProjectSession from "../../../model2/project/project-session"

// @ts-ignore
// import ColorSelector from "../../../gd-components/color/selector/selector"

type Props = {
    project     : ProjectSession
    onSubmit    : func
}

export default class ModalEditProject extends React.Component<Props> {

    public form: FormManager

    constructor(props: Props) {
        super(props)

        const { project } = this.props

        const initFormData = {
            name        : project.name,
            // color       : project.color,
            // projectIcon : project.projectIcon ? project.projectIcon : ProjectSystemTypeIcon[project.systemType]
        }

        const formStructure = {
            fields: {
                name: {
                    type: 'input',
                    isRequired: true
                },
                /*projectIcon: {
                    type: 'select',
                    isRequired: true
                },
                color: {
                    type: 'select',
                    isRequired: true
                }*/
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result: any) => {
        this.props.onSubmit(result)
    }

    /*onColorChange = (color: number) => {
        this.form.setValue('color', color)
    }*/

    render() {
        // const labelStyle = {paddingTop: '6px'}

        return (
            <Form form={this.form} submitLabel="Save" >
                <div className="tbl">
                    <div className="row">
                        <div className="label">Title</div>
                        <div className="element">
                            <Input size="big" form={this.form} name="name" />
                            <FormError form={this.form} name="name" />
                        </div>
                    </div>
                </div>

                {/*<div className="tbl">
                    <div className="row">
                        <div className="label" style={labelStyle}>Color</div>
                        <div className="element">
                            <ColorSelector value={this.form.getValue('color')}
                                           type="default-26"
                                           colorPrefix="gd-c-"
                                           onChange={this.onColorChange}/>
                            <FormError form={this.form} name="color" />
                        </div>
                    </div>
                </div>

                <div className="tbl">
                    <div className="row">
                        <div className="label">Icon</div>
                        <div className="element">
                            <SelectIcon iconType="project"
                                        form={this.form}
                                        renderValue="form"
                                        name="projectIcon" />
                            <FormError form={this.form} name="projectIcon" />
                        </div>
                    </div>
                </div>*/}
            </Form>
        )
    }
}
